export const Errors = {
    NOTES_REQ_APPROVAL_LOAD_FAILURE: 'Error attempting to load notes requiring approval.',
    NOTES_REQ_APPROVAL_APPROVE_ALL_FAILURE: 'Error attempting to approve all notes requiring approval.',
    NOTES_REQ_APPROVAL_MARK_READ_FAILURE: 'Error attempting to mark the message as read.',
    NOTES_REQ_APPROVAL_APPROVE_FAILURE: 'Error attempting to approve the note.',
    NOTES_REQ_APPROVAL_REJECT_FAILURE: 'Error attempting to reject the note.',
    NOTES_REQ_APPROVAL_PDF_LOAD_FAILURE: 'Error attempting to load the PDF.',
    NOTES_REQ_APPROVAL_PDF_OPEN_FAILURE: 'Error attempting to open the PDF.',
    NOTES_PENDING_ACTION_LOAD_FAILURE: 'Error attempting to load notes pending action.',
    NOTES_PENDING_ACTION_DELETE_ALL_FAILURE: 'Error attempting to delete approved notifications.',
    NOTES_PENDING_ACTION_MARK_READ_FAILURE: 'Error attemting to mark the message as read.',
    NOTES_PENDING_ACTION_DELETE_FAILURE: 'Error attemting to delete the message',
    LOGIN_FAILURE: 'Error attempting to login.',
    LOGOUT_FAILURE: 'Error attempting to log out.',
    SELECT_COMPANY_FAILURE: 'Error attempting to select the company.',
    LOAD_SESSION_FAILURE: 'Error attempting to load the user session.',
    LOCATION_LOADING_FAILURE: 'Error while getting the locations',
    CETS_PUNCH_IN_FAILURE: 'Error attempting to punch in to CETS.',
    MASTER_DATA_LOAD_FAILURE: 'Error attempting to load master data objects.',
    SEARCH_QUICK_FAILURE: 'Error attempting to perform a quick search.',
    SEARCH_FAILURE: 'Error attempting to search.',
    PATIENT_OPEN_FAILURE: 'Error atttempting to open the patient.',
    PATIENT_OPEN_IN_PROG_NOTE: 'Unable to initiate new note.  The patient already has an in-progress note.',
    PATIENT_LOAD_FAILURE: 'Error attempting to load the patient.',
    PATIENT_UPDATE_NOTES_FAILURE: 'Error attempting to update patient notes.',
    PATIENT_UPDATE_CONTRAIN_FAILURE: 'Error attempting to update contraindications.',
    PATIENT_ENABLE_RTM_FAILURE: 'Error attempting to enable RTM for the admission.',
    PATIENT_REFRESH_ADMISSIONS_FAILURE: 'Error attempting to refresh the admissions.',
    PATIENT_USE_PEDS_FAILURE: 'Error attempting to set peds template.',
    PATIENT_REFRESH_SCANS_FAILURE: 'Error attempting to refresh the scan docs.',
    PATIENT_PDF_OPEN_FAILURE: 'Error attempting to open the PDF.',
    PATIENT_PDF_LOAD_FAILURE: 'Error attempting to load the PDF.',
    PATIENT_AL_OPEN_FAILURE: 'Error attempting to open the Activity Log.',
    PATIENT_AL_LOAD_FAILURE: 'Error attempting to load the Activity Log.',
    PATIENT_OPEN_HEP_FAILURE: 'Failed to open the Home Exercise Plan.',
    PATIENT_CREATE_RTM_NOTE_FAILURE: 'Failed to create an RTM Note.',
    NOTE_SAVE_ADDENDUM_FAILURE: 'Error attempting to save addendum.',
    NOTE_DELETE_FAILURE: 'Error attempting to delete the note.',
    NOTE_START_FAILURE: 'Error attempting to start a new note.',
    NOTE_START_FAILURE_PERM: 'You do not have access to document for this location.',
    NOTE_START_FAILURE_DISC: 'Your Discipline is not valid for this admission.',
    DIARY_SAVE_FAILURE: 'Error attempting to save the new diary entry.',
    DIARY_LOAD_FAILURE: 'Error loading the message center diary items.',
    DIARY_MARK_READ_FAILURE: 'Failed to mark the diary message as read.',
    DIARY_RESOLVE_FAILURE: 'Failed to resolve the diary item.',
    PATIENT_SAVE_SPECIAL_PROG_FAILURE: 'Error attempting to save the specialty program request.',
    EVAL_TRANSFER_FAILURE: 'Error attempting to transfer the eval.',
    EVAL_PREPOPULATE_FAILURE: 'Error attempting to prepopulate the eval.',
    EVAL_START_BLANK_FAILURE: 'Error attempting to start the eval.',
    CDV_REFRESH_FAILURE: 'Error attempting to refresh the CDV.',
    NOTE_IN_PROG_OPEN_FAILURE: 'Error attempting to open the in-progress note.',
    NOTE_UPDATE_TEXT_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_UPDATE_BIT_FIELD_FAILURE: 'Error attempting to update the field.',
    AL_UPDATE_TIME_FAILURE: 'Error updating Activity log',
    NOTE_UPDATE_INT_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_UPDATE_DECIMAL_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_UPDATE_DATE_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_CLEAR_FIELD_FAILURE: 'Error attempting to clear the field.',
    NOTE_CLEAR_FIELDS_FAILURE: 'Error attempting to clear the fields.',
    NOTE_CLEAR_SPINE_FIELDS_FAILURE: 'Error attempting to clear the spine fields.',
    NOTE_ADD_TEMPLATE_FAILURE: 'Error attempting to add the template.',
    NOTE_REMOVE_TEMPLATE_FAILURE: 'Error attempting to remove the template.',
    NOTE_ADD_CHILD_ROW_FAILURE: 'Error attempting to add the item.',
    NOTE_ADD_CUSTOM_GOAL_FAILURE: 'Error attempting to add the custom goal.',
    NOTE_ADD_IND_HEP_GOAL_FAILURE: 'Error attempting to add the Independence with HEP goal.',
    NOTE_ADD_CHILD_ROW_GENERATOR_FAILURE: 'Error attempting to add the item.',
    NOTE_ADD_AL_ROW_FAILURE: 'Error attempting to add the item.',
    NOTE_REMOVE_CHILD_ROW_FAILURE: 'Error attempting to remove the item.',
    NOTE_UPDATE_AL_MOD_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_UPDATE_AL_OTHER_FIELD_FAILURE: 'Error attempting to update the field.',
    NOTE_CLEAR_AL_FAILURE: 'Error attempting to clear the Activity Log.',
    NOTE_GET_WARNING_FAILURE: 'Error attempting to get note warnings.',
    NOTE_GET_AL_TEMPLATE_FAILURE: 'Failed to get the Activity Log template.',
    NOTE_ADD_GOAL_TEMPLATES: 'Failed to add goal templates.',
    NOTE_APPLY_AL_TEMPLATE_FAILURE: 'Failed to apply the Activity Log template.',
    NOTE_SAVE_AL_TEMPLATE_FAILURE: 'Failed to save the Activity Log template.',
    NOTE_DELETE_AL_TEMPLATE_FAILURE: 'Failed to delete the Activity Log template.',
    NOTE_UNDO_DELETE_AL_TEMPLATE_FAILURE: 'Failed to restore the Activity Log template.',
    NOTE_ADD_GOAL_FAILURE: 'Failed to add the goal.',
    UPDATE_LTG_DATE_FAILURE: 'Failed to update short term goal dates.',
    UPDATE_STG_DATE_FAILURE: 'Failed to update long term goal dates.',
    NOTE_DELETE_GOAL_FAILURE: 'Failed to delete the goal.',
    NOTE_FAVORITE_GOAL_FAILURE: 'Failed to save the goal favorite.',
    NOTE_APPLY_FAVORITE_GOAL_FAILURE: 'Failed to apply goal favorite.',
    NOTE_CLEAR_GOALS_FAILURE: 'Failed to clear the goals.',
    NOTE_ADD_ASSESSMENT_FLAG_FAILURE: 'Failed to add short term goal".',
    NOTE_ADD_PLAN_SUB_CAT_FAILURE: 'Failed to add the item to the plan of care.',
    NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_FAILURE: 'Failed to update the assessment flags.',
    NOTE_UPDATE_ALL_GOAL_FLAGS_FAILURE: 'Failed to update the long term goal flags.',
    NOTE_CLEAR_AL_GROUP_FAILURE: 'Failed to clear the Activity Log group times.',
    NOTE_COMPUTE_CHARGES_FAILURE: 'Failed to compute charges.',
    ERROR_REPORT_FAILURE: 'Failed to submit the error report.  Please contact the help desk.',
    NOTE_SAVE_FINAL_FAILURE: 'Failed to save the note as final.',
    NOTE_CONVERT_FAILURE: 'Failed to convert the note.',
    NOTE_SAVE_OBJECTIVE_TEMPLATE_FAILURE: 'Failed to save the custom template.',
    DASHBOARD_LOAD_SCHEDULE_FAILURE: 'Failed to load the schedule.',
    DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE: 'Failed to load the schedule.',
    DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE: 'Failed to load the outstanding notes.',
    DC_DUE_LOAD_FAILURE: 'Failed to load notes requiring discharge.',
    DC_DUE_MARK_READ_FAILURE: 'Failed to mark DC due as read.',
    PN_DUE_LOAD_FAILURE: 'Failed to load notes requiring progress.',
    PN_DUE_DETAILS_LOAD_FAILURE: 'Failed to load the details for the note requiring progress.',
    PN_DUE_MARK_READ_FAILURE: 'Failed to mark PN due as read.',
    SPEC_PROG_REQS_LOAD_FAILURE: 'Failed to load the special program request messages.',
    SPEC_PROG_REQS_MARK_READ_FAILURE: 'Failed to mark the special program request message as read.',
    SPEC_PROG_REQS_REPLY_FAILURE: 'Failed to reply to the special program request message.',
    FED_REV_LOAD_FAILURE: 'Failed to load federal review messages.',
    FED_REV_MARK_READ_FAILURE: 'Failed to mark the federal review message as read.',
    FED_REV_REPLY_FAILURE: 'Failed to reply to the federal review message.',
    FED_REV_CLOSE_NOTIFICATION_FAILURE: 'Failed to delete the federal review message.',
    REQUEST_HELP_FAILURE: 'Failed to submit the help request.',
    NOTE_STARTING: 'A note is already being initialized.  Stand by...',
    NOTE_REOPEN_OWNER: 'Only notes you own can be opened by you.',
    NOTE_REOPEN_CLAIM: 'This note has charges on a claim, and cannot be re-opened. Contact charge addendums.',
    NOTE_REOPEN_CWS: 'CWS notes cannot be opened from sapphire.',
    USER_PREFERENCES_FAILURE: 'Failed to load the user preferences.',
    SAVE_USER_PREFERENCES_FAILURE: 'Error attempting to save the user preferences entry.',
}